<ion-app>
	<ion-router-outlet [swipeGesture]="true"></ion-router-outlet>
</ion-app>
